import { create } from 'zustand';

export const useProfileFormStore = create((set, get) => ({
  isEditingProfile: false,
  editName: '',
  editBio: '',
  editDescription: '',
  editPrice: 0,
  editPicture: '',

  setIsEditingProfile: (isEditing) => set({ isEditingProfile: isEditing }),
  setEditName: (name) => set({ editName: name }),
  setEditBio: (bio) => set({ editBio: bio }),
  setEditDescription: (description) => set({ editDescription: description }),
  setEditPrice: (price) => set({ editPrice: price }),
  setEditPicture: (picture) => set({ editPicture: picture }),

  initializeForm: (user) =>
    set({
      editName: user.name || '',
      editBio: user.bio || '',
      editDescription: user.description || '',
      editPrice: user.subscription_price || 0,
      editPicture: user.picture || '',
    }),

  getFormData: () => {
    const state = get();
    return {
      name: state.editName,
      bio: state.editBio,
      description: state.editDescription,
      subscription_price: state.editPrice,
      picture: state.editPicture,
    };
  },

  resetForm: () =>
    set({
      isEditingProfile: false,
      editName: '',
      editBio: '',
      editDescription: '',
      editPrice: 0,
      editPicture: '',
    }),
}));
